// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"48232026","224":"b174c170","252":"690ece32","420":"c745dd9e","480":"da145f5d","752":"7c05016b","784":"310fd594","808":"8e2a4e83"}[chunkId] + ".chunk.js";
};